/** Cover start and valuation date rules — aligned with agent motor sale. */

export function toLocalISO(date) {
  const d = date instanceof Date ? date : new Date(date);
  if (Number.isNaN(d.getTime())) return '';
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

export function todayIso() {
  return toLocalISO(new Date());
}

export function minCoverStartDate() {
  return todayIso();
}

export function maxCoverStartDate(refDate = new Date()) {
  return `${refDate.getFullYear() + 1}-01-31`;
}

export function isNextYearCoverStart(coverStartIso) {
  if (!coverStartIso) return false;
  const startYear = parseInt(String(coverStartIso).split('-')[0], 10);
  return startYear > new Date().getFullYear();
}

export function maxValuationDate(coverStartIso) {
  if (!coverStartIso) return null;
  const d = new Date(coverStartIso);
  d.setDate(d.getDate() + 30);
  return toLocalISO(d);
}

export function clampCoverStartDate(value) {
  if (!value) return value;
  const min = minCoverStartDate();
  const max = maxCoverStartDate();
  if (value < min) return min;
  if (value > max) return max;
  return value;
}

/** Parse yyyy-MM-dd or dd/MM/yyyy to yyyy-MM-dd. */
export function coverStartIsoFromAny(coverFrom) {
  if (!coverFrom || typeof coverFrom !== 'string') return todayIso();
  if (coverFrom.includes('-')) return coverFrom.slice(0, 10);
  if (coverFrom.includes('/')) {
    const [day, month, year] = coverFrom.split('/').map((x) => parseInt(x, 10));
    if (day && month && year) {
      return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
    }
  }
  return todayIso();
}
